import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { Client as Styletron } from "styletron-engine-atomic";
import { Provider as StyletronProvider } from "styletron-react";
import { LightTheme, BaseProvider } from "baseui";
import ProtectedRoute from "./components/redux/protectedRoutes.js";
import Login from "./components/features/login.js";
import ForgotPassword from "./components/features/auth/forgotPassword.js";
import ResetPassword from "./components/features/auth/resetPassword.js";
import Dashboard from "./components/features/dashboard.js";
import Users from "./components/features/settings/users.js";
import VehicleList from "./components/features/vehicles/vehicleList.js";
import Inspections from "./components/features/vehicles/inspections.js";
import VehicleDetails from "./components/features/vehicles/vehicleDetails.js";
import WindowSticker from "./components/features/vehicles/windowSticker.js";
import PullTlo from "./components/features/sales/pullTlo.js";
import Chats from "./components/features/sales/chats.js";
import EmployeeTraining from "./components/EmployeeTraining/employeeTraining.js";
import VehicleUpdateForm from "./components/vehicleUpdateForm.js";
import IncomingTable from "./components/incomingTable.js";
import { withMainLayout } from "./components/mainComponent.js";
import SerpResults from "./components/marketing/serpResults.js";
import UploadVehiclePhotos from "./components/features/photos/uploadVehiclePhotos.js";

const engine = new Styletron();

const App = () => {
  return (
    <StyletronProvider value={engine}>
      <BaseProvider theme={LightTheme}>
        <Router>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/admin/forgot-password" element={<ForgotPassword />} />
            <Route path="/admin/reset-password" element={<ResetPassword />} />
            <Route
              path="/vehicleUpdate"
              element={
                <ProtectedRoute>
                  {withMainLayout(VehicleUpdateForm)()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/incomingTable"
              element={
                <ProtectedRoute>
                  {withMainLayout(IncomingTable)()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>{withMainLayout(Dashboard)()}</ProtectedRoute>
              }
            />
            <Route
              path="/inspections"
              element={
                <ProtectedRoute>{withMainLayout(Inspections)()}</ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute>{withMainLayout(Users)()}</ProtectedRoute>
              }
            />
            <Route
              path="/employee-training"
              element={
                <ProtectedRoute>
                  {withMainLayout(EmployeeTraining)()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/vehicleList"
              element={
                <ProtectedRoute>{withMainLayout(VehicleList)()}</ProtectedRoute>
              }
            />
            <Route
              path="/vehicleDetails"
              element={
                <ProtectedRoute>
                  {withMainLayout(VehicleDetails)()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/window-sticker"
              element={
                <ProtectedRoute>
                  {withMainLayout(WindowSticker)()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/pull-tlo"
              element={
                <ProtectedRoute>{withMainLayout(PullTlo)()}</ProtectedRoute>
              }
            />
			<Route
              path="/serp-results"
              element={
                <ProtectedRoute>{withMainLayout(SerpResults)()}</ProtectedRoute>
              }
            />
            <Route
              path="/chats"
              element={
                <ProtectedRoute>{withMainLayout(Chats)()}</ProtectedRoute>
              }
            />
            <Route 
            path="/upload-vehicle-photos" 
            element={
              <ProtectedRoute>{withMainLayout(UploadVehiclePhotos)()}</ProtectedRoute>
            } />
            <Route path="*" element={<Navigate to="/dashboard" />} />
          </Routes>
        </Router>
      </BaseProvider>
    </StyletronProvider>
  );
};

export default App;
